<template>
    <div>
        <validation-observer ref="forms" v-slot="{handleSubmit}">
            <form class="form-group" @submit.prevent="handleSubmit(submitEvento)">
                <div class="grid-1 mb-4 form-2">

                    <validation-provider name="Nome" vid="nome" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Nome</label>
                        <input type="text" placeholder="Nome do evento" v-model="form.nome"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Publico Alvo" vid="publico_alvo" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Público Alvo</label>
                        <input type="text" placeholder="Publico alvo do evento" v-model="form.publico_alvo"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Tipo de evento" vid="tipo_evento" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Tipo de evento</label>
                        <select v-model="form.tipo_evento">
                            <option value="1">Presencial</option>
                            <option value="2">Online</option>
                            <option value="3">Misto</option>
                        </select>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <div>
                        <label>Liberar Cadastros</label>
                        <div class="mt-4 form-checkbox">
                            <label>
                                <span class="ml-4 text-dark-gray">
                                    {{ form.ativo ? 'Sim' : 'Não' }}
                                </span>
                                <input type="checkbox" id="liberarEvento" name="manchete" v-model="form.ativo"/>
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                </div>

                <div class="grid-1 form-2">
                    <validation-provider name="Data Início" vid="data_inicio" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Data de Início</label>
                        <flat-pickr v-model="form.data_inicio" :config="config" name="data-inicio" id="data-inicio"
                                    placeholder="Data de início do evento"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Data Término" vid="data_termino" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Data de Término</label>
                        <flat-pickr v-model="form.data_termino" :config="config" name="data-termino" id="data-termino"
                                    placeholder="Data de término do evento"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Horário Início" vid="data_termino" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Horário de Início</label>
                        <input type="text" placeholder="Hora de início do evento" v-mask="'##:##'" maxlength="5"
                               v-model="form.hora_inicio"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Horário Término" vid="data_termino" rules="required" v-slot="{errors}"
                                         tag="div" class="input-std form-text">
                        <label>Horário de Término</label>
                        <input type="text" placeholder="Hora de término do evento" v-mask="'##:##'" maxlength="5"
                               v-model="form.hora_termino"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="my-4">
                    <validation-provider name="Imagem do Evento" vid="imagem-evento" rules="required" v-slot="{errors}"
                                         tag="div">
                        <label> Foto do Evento</label>
                        <input-file :title="'Foto do Evento'" url="imagem-evento" :name="'imagem'" id="imagem-evento"
                                    :value="imagens" @changeFile="imagens = $event.files"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="mt-8 grid-1 form-3">
                    <validation-provider name="Local" vid="local" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Local</label>
                        <input type="text" placeholder="Local do evento" v-model="form.local"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Cep" vid="cep" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>CEP</label>
                        <input @blur="buscaCep" v-mask="'#####-###'" maxlength="9" type="text"
                               placeholder="CEP do evento" v-model="form.cep"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Endereço" vid="nome" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Endereço</label>
                        <input type="text" placeholder="Endereço do evento" v-model="form.endereco"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Número" vid="numero" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Número</label>
                        <input type="text" placeholder="Número do endereço" v-model="form.numero"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="grid-2 form-4">
                    <validation-provider name="Bairro" vid="bairro" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Bairro</label>
                        <input type="text" placeholder="Bairro do evento" v-model="form.bairro"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>

                    <validation-provider name="Cidade" vid="cidade" rules="required" v-slot="{errors}" tag="div"
                                         class="input-std form-text">
                        <label>Cidade</label>
                        <input type="text" placeholder="Cidade do evento" v-model="form.cidade"/>
                        <p class="errors">{{ errors[0] }}</p>
                    </validation-provider>
                </div>

                <div class="flex justify-end">
                    <button class="btn btn-primary">
                        {{ (!form.id) ? 'Salvar Evento' : 'Atualizar Evento' }}
                    </button>
                </div>
            </form>
        </validation-observer>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';
import {mask} from "vue-the-mask"

const Brasil = require('flatpickr/dist/l10n/pt.js').default.pt;
export default {
    name: 'form-evento',
    components: {
        flatPickr
    },
    directives: {mask},

    created() {
        this.popularEvento()
    },
    data() {
        return {
            imagens: [],
            form: {
                nome: '',
                local: '',
                endereco: '',
                numero: '',
                cidade: '',
                bairro: '',
                cep: '',
                publico_alvo: '',
                data_inicio: '',
                data_termino: '',
                hora_inicio: '',
                hora_termino: '',
                ativo: '',
                tipo_evento: 1,
                id: null
            },
            config: {
                wrap: true,
                altInput: true,
                altFormat: 'd/m/Y',
                dateFormat: 'Y-m-d',
                enableTime: false,
                allowInput: true,
                locale: Brasil,
            },
        }
    },

    methods: {
        async popularEvento() {
            if (this.$route.params.id) {
                let evento = await this.getEvento(this.$route.params.id)
                for (var key in evento) {
                    this.form[key] = evento[key]
                }
                this.imagens = evento.imagem_evento.map(imagem => {
                    return {
                        id: imagem.id,
                        imagem: imagem.imagem
                    }
                });
            }
        },

        async getEvento(id) {
            let result = await this.axios('eventos/' + id)
            return result.data.evento
        },

        buscaCep() {
            let cep = this.form.cep.replace('-', '')
            if (cep.length === 8) {
                this.axios.get('https://viacep.com.br/ws/' + cep + '/json/', {baseURL: 'viacep.com.br'}).then(response => {
                    this.form.endereco = response.data.logradouro
                    this.form.bairro = response.data.bairro
                    this.form.cidade = response.data.localidade
                    this.form.numero = ''
                    this.$store.commit('loadingScreen/setLoading', false);
                }).catch(error => {
                    this.$store.commit('loadingScreen/setLoading', false);
                    this.form.endereco = ''
                    this.form.bairro = ''
                    this.form.cidade = ''
                    this.form.numero = ''
                    console.error(error)
                })
            } else {
                this.form.endereco = ''
                this.form.bairro = ''
                this.form.cidade = ''
                this.form.numero = ''
            }
        },

        submitEvento() {
            this.form.ativo ?
                this.form.ativo = 1 :
                this.form.ativo = 0

            this.axios.post('eventos', this.form)
                .then(res => {
                    if (res.status === 200) {
                        let imagens = {
                            evento_id: res.data.evento.id,
                            imagem: this.imagens
                        }

                        this.axios.post('imagem-evento', imagens)
                            .then(res => {
                                if (res.status === 200) {
                                    this.$swal({
                                        title: 'Sucesso',
                                        text: (this.form.id) ? 'O evento foi atualizado com sucesso' : 'O evento foi criado com sucesso',
                                        icon: 'success',
                                    })
                                    this.$router.push('/sistema/eventos/lista-eventos')
                                }
                            })
                            .catch(error => {
                                this.$swal({
                                    title: 'Ops!',
                                    text: error.response.data.message,
                                    icon: 'error',
                                });

                            })

                    }
                })
                .catch(error => {
                    this.$swal({
                        title: 'Ops!',
                        text: error.response.data.message,
                        icon: 'error',
                    });
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.form-1 {
    @media(min-width: 640px) {
        @apply grid-cols-3;
    }
}

.form-2 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}

.form-3 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
    @media(min-width: 1024px) {
        @apply grid-cols-4;
    }
}

.form-4 {
    @media(min-width: 640px) {
        @apply grid-cols-2;
    }
}
</style>
